var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "track-and-trace-editor d-flex flex-column"
  }, [_c('div', {
    staticClass: "cms-editor-ctn mt-2 pa-3 pl-0 d-flex flex-row flex-grow-1"
  }, [_c('div', {
    staticClass: "toolbox-ctn px-3 font-weight-light flex-shrink-0"
  }, [_c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(" " + _vm._s(_vm.$t('trackandtrace_think_about_steps'))), _c('br'), _c('br'), _vm._v(" " + _vm._s(_vm.$t('trackandtrace_each_step_location_pin'))), _c('br'), _c('br'), _vm._v(" " + _vm._s(_vm.$t('trackandtrace_click_icon_to_configure_pre')) + " "), _c('v-icon', {
    attrs: {
      "color": "accent"
    }
  }, [_vm._v("mdi-cog-outline")]), _vm._v(" " + _vm._s(_vm.$t('trackandtrace_click_icon_to_configure_post')) + " ")], 1), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "text": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.createStep
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t('trackandtrace_add_new_step')) + " ")], 1)], 1), _c('div', {
    staticClass: "drop-area-ctn flex-grow-1 flex-shrink-1 pa-2"
  }, [_c('div', {
    staticClass: "drop-area-header font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('trackandtrace_working_area')))]), _c('draggable', {
    staticClass: "drop-area flex-shrink-1",
    attrs: {
      "group": "a"
    },
    model: {
      value: _vm.journey,
      callback: function callback($$v) {
        _vm.journey = $$v;
      },
      expression: "journey"
    }
  }, _vm._l(_vm.journey, function (step, index) {
    return _c('div', {
      key: "journey-step-".concat(_vm.tabId, "-").concat(step.key),
      staticClass: "journey-step my-2"
    }, [_c('journey-step', {
      ref: "step-".concat(index),
      refInFor: true,
      attrs: {
        "step-index": index,
        "step": step
      }
    })], 1);
  }), 0)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }